export enum INSTANCE_SETTINGS {
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=9585134 */
    GLOBAL_SETTINGS = 'ADMIN.ADVANCED_SETTINGS.DEFAULT_CATEGORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=27470083
     */
    SITE_NAME = 'ANALYTICS.SITES.TABLE_HEAD_NAME',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452097
     */
    PARENT_SITE = 'ADMIN_INSTANCE_PARENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452082
     */
    DEFAULT_LANGUAGE = 'ADMIN_INSTANCE_DEFAULT_LANG',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=15926543
     */
    INVALID_GOOGLE_ANALYTICS = 'SERVER_ERROR_INVALID_GOOGLE_ANALYTICS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=309748424
     */
    GOOGLE_ANALYTICS_HELPER = 'INSTANCE_SETTINGS.GOOGLE_ANALYTICS_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=9585124
     */
    RESTRICT_TO = 'ADMIN.INSTANCE.RESTRICT_TO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7139911
     */
    IN_FAVORITE_FEEDS = 'ADMIN.INSTANCE.IN_FAVORITE_FEEDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7141189
     */
    IS_DELETABLE_FROM_FAVORITE = 'ADMIN.INSTANCE.IS_DELETABLE_FROM_FAVORITE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452087
     */
    GOOGLE_TAG_MANAGER = 'ADMIN_INSTANCE_GOOGLE_TAG_MANAGER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=15926485
     */
    INSTANCE_SLUG_EXIST = 'SERVER_ERROR_ADMIN_INSTANCE_SLUG_EXIST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=15926544
     */
    INVALID_GOOGLE_TAG_MANAGER = 'SERVER_ERROR_INVALID_GOOGLE_TAG_MANAGER',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452081
     */
    DEFAULT_INSTANCE = 'ADMIN_INSTANCE_DEFAULT_INSTANCE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452102
     */
    SEARCH_PARENT_LIST_CHILDREN = 'ADMIN_INSTANCE_SEARCH_PARENT_LIST_CHILDREN',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452101
     */
    SEARCH_CHILDREN_LIST_PARENT = 'ADMIN_INSTANCE_SEARCH_CHILDREN_LIST_PARENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452100
     */
    SEARCH_CHILDREN_LIST_CHILDREN = 'ADMIN_INSTANCE_SEARCH_CHILDREN_LIST_CHILDREN',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452098
     */
    PUBLIC_CONTENT = 'ADMIN_INSTANCE_PUBLIC_CONTENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452111
     */
    INSTANCE_THEME = 'ADMIN_INSTANCE_THEME',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452078
     */
    INSTANCE_CONFIGURATION = 'ADMIN_INSTANCE_CONFIGURATION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452096
     */
    INSTANCE_OVERRIDE = 'ADMIN_INSTANCE_OVERRIDE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452093
     */
    SITE_METADATA = 'ADMIN_INSTANCE_METADATA',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=10314850
     */
    ERROR_WHILE_LOADING_INSTANCE = 'LOADING.ERROR.INSTANCE.GET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=9585136
     */
    ADVANCED_SETTINGS = 'ADMIN.INSTANCE.ADVANCED_SETTINGS',
}
